import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { Getters, Mutations, Actions, DriversLeave } from '@/models/DriverLeave.model';

// Inital state
const state: DriversLeave = {
  driversLeave: [],
};

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, DriversLeave> = {
  driversLeave: (state) => state.driversLeave,
};

// TODO: Change mutation names to uppercase ( Standards )
// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, DriversLeave> = {
  setDriversLeave(state, { driversLeave }) {
    state.driversLeave = driversLeave;
  },
};

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, DriversLeave, Mutations, Getters> = {
  setDriversLeave({ commit }, payload) {
    commit('setDriversLeave', payload);
  },
};

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<DriversLeave, Getters, Mutations, Actions>('DriversLeaveModule');

export const DriversLeaveModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
